import { Icon, toIconsEnum } from 'components/Icons';
import { selectAvvenimentoById, selectSistema } from '../../virtualTicketSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { SimpleCheckbox } from 'components/inputs/simpleCheckbox';
import { VirtualTicketItemEsito } from '../virtualTicketItemEsito';
import { avvenimentoUpdatedOnFisso } from '../../virtualTicketSlice';
import { memo } from 'react';
import styles from './VirtualTicketItem.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

export type VirtualTicketItemProps = {
  avvenimentoId: string;
  cancelBtn?: boolean;
};

const PREFIX_ICON = 'DISCIPLINA';

export const VirtualTicketItem = memo(function VirtualTicketItem({
  avvenimentoId,
  cancelBtn = true,
}: VirtualTicketItemProps) {
  const dispatch = useAppDispatch();
  const avvenimento = useTypedSelector((state) => selectAvvenimentoById(state, avvenimentoId));
  const isSistema = useTypedSelector(selectSistema);
  const disciplinaIcon = `${PREFIX_ICON}_${avvenimento?.idDisciplina}`;
  const [labelPal, labelFixed] = useGetLabelsByKeys(['pal', 'fixed']);

  const handleChangeCheckbox = (element: HTMLInputElement) => {
    dispatch(
      avvenimentoUpdatedOnFisso({
        idAvvenimento: avvenimento?.idAvvenimento!,
        isFisso: element.value === 'true' ? false : true,
      })
    );
  };

  return (
    <article className={styles.container}>
      <div className={styles.firstCol}>
        <ul className={styles.list}>
          <li className={`${styles.item} ${styles.smallText}`}>
            <Icon iconId={toIconsEnum(disciplinaIcon)} className={styles.icon} color={'var(--color-on-bg-secondary)'} />
            {avvenimento?.disciplina}
          </li>
        </ul>

        <p className={styles.competitors}>{avvenimento?.descrizione}</p>
      </div>
      <div className={styles.secondCol}>
        <span className={styles.smallText}>
          {labelPal} {`${avvenimento?.palinsesto}`}
        </span>
        {isSistema && (
          <SimpleCheckbox
            value={String(avvenimento?.isFisso)}
            checked={String(avvenimento?.isFisso) === 'true'}
            handleFilterChange={(e) => handleChangeCheckbox(e)}
            className={styles.checkbox}
            label={labelFixed}
          />
        )}
      </div>

      {
        <ul className={`${styles.scommessaList} ${isSistema ? styles.hasBigMargin : ''}`}>
          {avvenimento?.esiti &&
            avvenimento.esiti?.map((esitoItem) => {
              const { descrizioneTipoScommessa, descrizione, id: esitoId, isActive, quota } = esitoItem;

              const quotaDividedHundred = quota / 100;
              return (
                <VirtualTicketItemEsito
                  key={`ticket-esito-${esitoId}`}
                  esitoId={esitoId}
                  isActive={isActive}
                  cancelBtn={cancelBtn}
                  descrizioneEsito={descrizione}
                  quotaDividedHundred={quotaDividedHundred}
                  descrizioneTipoScommessa={descrizioneTipoScommessa}
                />
              );
            })}
        </ul>
      }
    </article>
  );
});
